module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "extract"
  }, [_c('div', {
    staticClass: "row-extract"
  }, [_c('div', {
    staticClass: "yellow-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "red-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "purple-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "blue-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "green-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row-extract"
  }, [_c('div', {
    staticClass: "box-mm"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/logo-move-mais-extrato.svg"),
      "alt": "logo move mais",
      "width": "255px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title-extract bold"
  }, [_vm._v("EXTRATO")])]), _vm._v(" "), _c('div', {
    staticClass: "row-extract row-red margin-t20"
  }, [_c('div', {
    staticClass: "period bold"
  }, [_c('p', [_vm._v("Período")]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("01/06/2016 á 31/07/2016")])])]), _vm._v(" "), _c('div', {
    staticClass: "row-extract margin-t20"
  }, [_c('table', {
    staticClass: "table stripped-odd stripped"
  }, [_c('thead', [_c('tr', {
    staticClass: "row-red"
  }, [_c('th', {
    attrs: {
      "width": "70%"
    }
  }, [_vm._v("Tipo de transação")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Quantidade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Valor em R$")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("passagem")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("741")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("-6.008,70")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("taxa de recarga manual")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("-1.600,00")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("adesao servico move mais")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("-119,70")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("pagamento/credito manual")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("1.719,70")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row-extract margin-t20"
  }, [_c('table', {
    staticClass: "table detail stripped-odd stripped"
  }, [_c('thead', [_c('tr', {
    staticClass: "row-red"
  }, [_c('th', {
    attrs: {
      "width": "17%"
    }
  }, [_vm._v("Data Processamento")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Data Ocorrência")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "23%"
    }
  }, [_vm._v("Tipo Transação")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Categoria")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Local")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Valor")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("adesao servico move mais")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("-39,90")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("adesao receita mm")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("39,90")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("adesao servico move mais")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("-39,90")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("adesao receita mm")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("39,90")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("adesao adic serv move mais")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("-119,70")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("passagem")]), _vm._v(" "), _c('td', [_vm._v("ABC1234")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("SP 300 - km 120")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("-10,70")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("passagem")]), _vm._v(" "), _c('td', [_vm._v("ABC1234")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("SP 300 - km 120")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("-10,70")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("25/07/2016 18:16")]), _vm._v(" "), _c('td', [_vm._v("passagem")]), _vm._v(" "), _c('td', [_vm._v("ABC1234")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("SP 300 - km 120")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("-10,70")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-01f9e16a!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pdf/extract.vue
// module id = 2033
// module chunks = 1